import { useEffect, useState } from 'react'
import { Select } from 'src/components/select'

import './style.scss'

const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const hours = [
  { label: '12:00 am', value: '12:00 am' },
  { label: '1:00 am', value: '1:00 am' },
  { label: '2:00 am', value: '2:00 am' },
  { label: '3:00 am', value: '3:00 am' },
  { label: '4:00 am', value: '4:00 am' },
  { label: '5:00 am', value: '5:00 am' },
  { label: '6:00 am', value: '6:00 am' },
  { label: '7:00 am', value: '7:00 am' },
  { label: '8:00 am', value: '8:00 am' },
  { label: '9:00 am', value: '9:00 am' },
  { label: '10:00 am', value: '10:00 am' },
  { label: '11:00 am', value: '11:00 am' },
  { label: '12:00 pm', value: '12:00 pm' },
  { label: '1:00 pm', value: '1:00 pm' },
  { label: '2:00 pm', value: '2:00 pm' },
  { label: '3:00 pm', value: '3:00 pm' },
  { label: '4:00 pm', value: '4:00 pm' },
  { label: '5:00 pm', value: '5:00 pm' },
  { label: '6:00 pm', value: '6:00 pm' },
  { label: '7:00 pm', value: '7:00 pm' },
  { label: '8:00 pm', value: '8:00 pm' },
  { label: '9:00 pm', value: '9:00 pm' },
  { label: '10:00 pm', value: '10:00 pm' },
  { label: '11:00 pm', value: '11:00 pm' },
]

const defaultState = {
  Sun: { active: false, from: '9:00 am', to: '3:00 pm' },
  Mon: { active: true, from: '9:00 am', to: '3:00 pm' },
  Tue: { active: true, from: '9:00 am', to: '3:00 pm' },
  Wed: { active: true, from: '9:00 am', to: '3:00 pm' },
  Thu: { active: true, from: '9:00 am', to: '3:00 pm' },
  Fri: { active: true, from: '9:00 am', to: '3:00 pm' },
  Sat: { active: false, from: '9:00 am', to: '3:00 pm' },
}

const BusinessHours = ({ value = null, onChange = () => {} }) => {
  const [state, setState] = useState({})
  // const [toHours, setToHours] = useState({})

  useEffect(() => {
    setState(defaultState)

    // const newToHours = {
    //   'Sun': fromHours('Sun'),
    //   'Mon': fromHours('Mon'),
    //   'Tue': fromHours('Tue'),
    //   'Wed': fromHours('Wed'),
    //   'Thu': fromHours('Thu'),
    //   'Fri': fromHours('Fri'),
    //   'Sat': fromHours('Sat'),
    // }

    // console.log(typeof state)
    // console.log(typeof value)

    // console.log(Object.keys(state))
    // console.log(Object.keys(value))

    /*
    console.log('BusinessHours', value, state)
    console.log(shallowEqualObjects(value, state))

    if (!value) {
      setState(defaultState);
      return;
    }

    if (!shallowEqualObjects(value, state)) {
      console.log(shallowEqualObjects(value, state))
      setState(value)
    }
    */
  }, [value])

  useEffect(() => {
    onChange(state)
  }, [state])

  const toggleActive = (x) => () => {
    const newState = { ...state }
    newState[x].active = !newState[x]?.active
    setState(newState)
  }

  const handleFromChange = (x, val) => {
    const newState = { ...state }
    newState[x].from = val
    setState(newState)
  }

  const handleToChange = (x, val) => {
    const newState = { ...state }
    newState[x].to = val
    setState(newState)
  }

  const fromHours = (key) => {
    const options = []

    let isNeed = false
    hours.forEach((x) => {
      if (x.value === state[key]?.from) isNeed = true

      if (isNeed) {
        options.push(x)
      }
    })

    // if (!options.find(op => op.value === state[key].to)) {
    //   state[key].to = options[0]
    // }

    return options
  }

  return (
    <div className="business-hours">
      {weekDays.map((x) => (
        <div
          key={x}
          className={state[x]?.active ? 'col-day active' : 'col-day'}
        >
          <div className="on-off" onClick={toggleActive(x)} />
          <div className="name">{x}</div>
          <Select
            isDisabled={!state[x]?.active}
            placeholder="Type"
            value={state[x]?.from}
            onChange={(item) => {
              handleFromChange(x, item.value)
            }}
            options={hours}
          />
          <div className="sep">-</div>
          <Select
            isDisabled={!state[x]?.active}
            placeholder="Type"
            value={state[x]?.to}
            onChange={(item) => {
              handleToChange(x, item.value)
            }}
            options={fromHours(x)}
          />
        </div>
      ))}
    </div>
  )
}

export default BusinessHours
